import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const haumeaChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      -14038050538.972761, 28062913.210943062, 3415061.0130657512, 5578.2350520451864, -8377.5820821126308, 108.42825050354004, 94.703533458709714, 46.76923863093058,
      -5.0664339383443195, -24.073158041636148, -5.6385881423950197, 3.8288708368937172,
    ]),
    new Float64Array([
      -2365393435.2433357, -288650437.20603448, 507248.11566961603, 72014.710021412378, 391.94003098408382, -604.23053537607188, -8.2793493191401168, -76.393776468435917,
      5.5094804803530373, 24.337518902619678, 5.8151710828145342, -5.235269335905711,
    ]),
    new Float64Array([
      5884235698.7970095, -51046833.051962629, -1347766.5222053686, 25235.504622443517, 499.82508446375527, -119.27434178988139, -97.260145521163935, -161.70740032196045,
      12.16116221745809, 60.186982520421346, 10.63778756459554, -11.845035092035928,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      -13873353421.559286, 53841831.719946921, 2909430.1616053898, -53601.480997085571, 7407.8213719050091, 1844.7198198318481, 36.744288158416751, -60.257624181111652,
      -11.537185351053873, 7.1225885073343909, -7.8882623990376786, -1.5578233400980632,
    ]),
    new Float64Array([
      -3507593298.0067158, -282042175.1448586, 972422.98138244147, -23743.264647555352, -9243.142531315485, 837.18474505742392, 256.46221503416695, 41.309054112434389,
      -4.9487225453058876, -20.112080470720926, 0.20759254296620686, 2.4294343550999957,
    ]),
    new Float64Array([
      5659956781.8698158, -60960935.344471931, -1200338.64504927, -14003.098027769724, -3943.2788407325743, 351.16329919497173, -70.908125321070358, -29.7185533841451,
      17.306302197774251, 10.979593276977539, 16.295696783065797, -2.4494649569193521,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      -13611375177.239481, 77433236.294259042, 3211929.3458871203, 55369.591082413994, -6618.39742714564, -723.9193883577982, 271.48357502619427, -89.487843672434494,
      -10.061441612243652, 26.721895503997803, -3.7171038309733073, -7.1709307670593256,
    ]),
    new Float64Array([
      -4622491483.593935, -275593818.14728832, 793737.54109936557, 49280.513963452977, 8119.8518894195558, -974.44545720418296, 23.990785590807597, -139.52719151973724,
      -9.289077202479044, 65.137572503089899, -5.5597973585128786, -12.544668571154276,
    ]),
    new Float64Array([
      5395527812.9187651, -71391635.809710458, -1345576.9705160935, 14725.605198065439, 3936.1123024145763, -461.54288927714032, -195.94229075113932, 10.336302344004313,
      16.956721544265747, 0.55067545572916665, 14.447822141647338, -0.2009418487548828,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      -13249026192.364887, 103673078.20774244, 3135194.4714921634, -61912.150095303856, -4496.1748430569969, 833.98375043869021, 238.63521639506021, 40.289742183685306,
      -10.555966472625732, -9.5536265691121418, -3.7459734598795573, 3.5009451866149903,
    ]),
    new Float64Array([
      -5707250945.5441837, -266131730.58055565, 1550426.6958518664, 38494.904067150754, -8507.4698549429577, -719.78565473556523, 140.634903494517, 1.0417206128438314,
      -6.7221781094868973, 4.9149925072987877, -5.7534653504689537, -2.3002135594685873,
    ]),
    new Float64Array([
      5090135031.7594566, -81070771.350374728, -1077227.426401488, 13340.553586117427, -3351.7551873524985, -499.22808341979982, -46.789964739481604, 136.95497994422914,
      7.5794125715891516, -49.914070574442547, 5.9516108194986979, 9.1787723859151207,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      -12787766630.444715, 126696475.38177878, 2855763.354899311, 54350.106305217741, 6064.8052452723186, -2401.8011903127035, -96.700870291392008, 160.60792229970295,
      1.875203514099121, -34.660157076517741, 1.0514400800069172, 9.5678309758504234,
    ]),
    new Float64Array([
      -6747159963.93715, -254012731.19278124, 1369612.7882950306, -10165.028242937724, 11153.278240505853, 792.34822276433306, -333.86779457728068, -93.589171663920084,
      8.4349920590718579, 36.837386560440066, 0.43915214538574215, -5.6196723461151121,
    ]),
    new Float64Array([
      4748276922.1526556, -89978177.460230798, -1201727.8678411802, -9886.1686023712155, 4635.5015972932179, 171.32582275072733, -100.84867142041524, 128.60654031435649,
      -0.8090861161549886, -48.577221600214642, -3.3691204388936362, 10.120555067062378,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      -12231990956.49362, 151466215.15121648, 3164971.5479134559, -31213.693987019855, -7136.2897209485373, 363.23697636922202, -141.52551695505778, -152.29997736612955,
      16.820695082346599, 60.950108051300049, 9.0589704195658367, -12.105534807840982,
    ]),
    new Float64Array([
      -7738624588.3306131, -241183921.11059555, 1978255.82611715, 69508.577226797745, -2685.828344329198, -763.69916981061294, -124.52023711204528, 75.845040321350098,
      11.448309357961019, -30.079545879364012, 7.0155321598052973, 6.1501253604888912,
    ]),
    new Float64Array([
      4369894977.3413982, -99029962.094297871, -996664.91443363822, 26565.427775144577, -1199.6710698763529, -426.75824581782024, 121.74970928827922, 126.32735981941222,
      -13.181918986638387, -49.24699279467265, -11.381340154012044, 9.7162642637888581,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      -11579604657.864418, 174148049.90588281, 2518846.5421117465, -16073.897288417817, 13923.523983160654, 676.36133279800413, -365.59509944915771, -75.068578815460199,
      8.2025008519490559, 12.368266518910726, 0.97581558227539056, -6.4849924405415855,
    ]),
    new Float64Array([
      -8668822324.4152641, -223764352.9822205, 2153462.0625433126, -44903.825571870802, -1450.9173374970753, 2110.2785187880199, -43.427982076009116, -88.660705788930258,
      11.062316401799519, 20.141368357340493, 11.759705050786335, -3.0206386248270669,
    ]),
    new Float64Array([
      3958889329.5028596, -106429860.25278616, -948962.26726354752, -22358.72143940131, -1227.3362240076065, 909.63441646099091, 200.42549560864765, -36.109375770886736,
      -17.335073057810465, 7.6472733418146772, -12.758864275614421, -1.0812209526697794,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      -10840540125.382126, 195780950.40284792, 2938074.0384822846, 16081.191708946228, -8387.539479605357, 119.96376914978028, 152.64270025889078, -69.779101212819413,
      -7.2121436119079592, 17.136317984263101, -7.01938845316569, -4.2927817344665531,
    ]),
    new Float64Array([
      -9530536953.9145126, -206993013.90813002, 2275132.7355675059, 69581.566912619266, 2615.2223614692689, -1057.146445687612, -57.771167532602945, 169.81063785552979,
      10.798687076568603, -67.273042106628424, 11.893050130208334, 11.662385431925456,
    ]),
    new Float64Array([
      3517213722.6121826, -114406278.280223, -944883.7606317997, 26594.046290191014, 1188.5309743165969, -339.37327841917676, 111.51828100681304, -34.852321235338849,
      -9.8868923028310132, 13.187694096565247, -7.17957227230072, -2.9183020194371543,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      -10012027754.277195, 218072216.43493029, 2472191.7184714633, -69347.927809937799, 3124.5875769933064, 1902.9470565478007, 95.24868570963541, -139.3538263320923,
      -7.014420127868652, 41.891445414225259, -2.1758943557739259, -7.9013715744018551,
    ]),
    new Float64Array([
      -10317283337.631601, -185848989.83855355, 2886383.5407725652, -1108.0751979509989, -10000.019242890676, 101.10318504969278, 126.98363021214803, -21.397397391001384,
      7.1697849909464519, 18.082905101776124, 8.3506708145141602, -1.571481959025065,
    ]),
    new Float64Array([
      3046371779.8617258, -120803670.89954565, -702949.63018868759, -965.62897299925487, -4384.0140830596283, 156.98856484889984, 69.10456569194794, -161.81024000644683,
      1.7477949937184651, 67.039142409960434, 2.2480040311813356, -12.07805552482605,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      -9102012379.7511692, 236984991.50995719, 2512776.8938482604, 52824.817431418101, -4312.9989289601644, -1452.8716729482014, 320.08515030543009, 28.148440233866374,
      -16.199377854665119, -9.9034023920694985, -5.412080987294515, 0.031239859263102212,
    ]),
    new Float64Array([
      -11016205622.977644, -163810875.30605507, 2703249.487589105, 37638.746488793688, 10477.161911455791, -994.31122096379602, -180.68929354349771, 159.75203011830646,
      2.7021738052368165, -51.354297828674312, 0.97235355377197263, 9.1471750259399407,
    ]),
    new Float64Array([
      2551053056.4282026, -126963031.58905925, -807011.8051472425, 13364.069027415911, 4773.8345422824223, -206.18624797662099, -198.52190719445545, -84.620330429077143,
      13.63211052417755, 35.938967943191528, 10.535759528477987, -7.5417505741119379,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      -8112609888.0864153, 257650034.19009718, 2433184.3027114552, -67186.186272017163, -6135.0800898551943, 417.10449258486432, 184.61641138394674, 67.993057235081992,
      -7.8297888278961176, -15.692097679773966, -4.4472821076711018, 5.1893820762634277,
    ]),
    new Float64Array([
      -11623369320.616562, -139077687.64939553, 3503990.9440414747, 54455.103663444519, -6785.9016922950741, -741.37533953984575, 86.682205518086747, -51.991768519083656,
      -6.9247517585754395, 25.281559181213378, -7.7267562548319502, -4.6895688692728674,
    ]),
    new Float64Array([
      2032220454.3825464, -132167000.14990424, -476607.26115188596, 24218.457150880495, -2365.8612317959469, -234.63869740962983, -170.35697659651439, -80.789164717992151,
      18.131098651885985, 31.811630113919577, 13.628277397155761, -6.5466886123021446,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2493072000 as Seconds,
    new Float64Array([
      -7158748434.8910408, 218077429.86755028, 1155076.9633152802, 3846.4529982566833, 5894.2353315353394, -252.74737172126768, -135.61379303932191, 0.49025570551554359,
      5.4010418097178139, -4.071978028615316, -2.6788017749786377, 1.5916947682698568,
    ]),
    new Float64Array([
      -12080329783.051144, -90717728.864126235, 2213576.7642617542, -20827.515640799204, 2061.2186396598818, 631.94667981465659, -69.466017595926914, -5.2272321383158369,
      12.112312030792236, 4.2651641209920248, -1.3820102373758951, -1.6544698397318522,
    ]),
    new Float64Array([
      1550982007.2873425, -108296971.20550515, -309561.62247111002, -9187.0584691643708, 936.14781792958581, 427.48925283749895, -111.45005565881729, -11.861423766613006,
      29.442210813363392, -7.2340832829475401, -3.6594347437222798, 2.8230140805244446,
    ])
  ),
];
